import { Factory } from 'fishery';
import { commodityFactory } from '@trukt/factories/commodityFactory';
import { SearchOrderCommoditiesResponse } from './OrderCommodityServices.types';

export const searchOrderCommoditiesResponseFactory = Factory.define<SearchOrderCommoditiesResponse>(
  () => ({
    page: 1,
    rows: 5,
    total: 100,
    results: commodityFactory.buildList(5),
  }),
);
